import React, { createContext,useEffect, useMemo, useRef, useState } from 'react'
import styles from "../css/Notes.module.css"
import UserMenu from './UserMenu'
import { TbArrowsSort } from "react-icons/tb";
import { IoFunnel } from "react-icons/io5";
import { BsPlus  } from "react-icons/bs";
import SortMenu, { attrDict, sortIcons } from './SortMenu';
import FilterMenu from './FilterMenu';
import Settings from '../../settings/js/Settings';
import NoteCard from './NoteCard';
import DeleteNote from '../../modals/js/DeleteNote';
import AddNote from '../../modals/js/AddNote';
import EditNote from '../../modals/js/EditNote';
import ViewNote from '../../modals/js/ViewNote';
import SkeletonPage, { SkeletonNoteContainer } from './SkeletonPage';
import CrashPage from '../../Error/js/CrashPage';
import { useDispatch, useSelector } from 'react-redux';
import { getNotes } from '../../../actions/noteActions';
import { CRASH_ERROR, SET_FILTERS, SET_SEARCH, SET_SORTING } from '../../../actions/noteTypes';
import LogoItem from "../../Logo/LogoItem"
import { FaArrowDownLong, FaArrowUpLong } from "react-icons/fa6";
import NoNotes from './NoNotes';
import EmptyResults from './EmptyResults';
import DemoToast from './DemoToast';
import { toast } from 'react-toastify';
import UseViewportPadding from '../../../hooks/useViewportPadding';

export const PageContext = createContext()
const Notes = () => {
    const [showUserMenu,setShowUserMenu] = useState(false)
    const [showFilterMenu,setShowFilterMenu] = useState(false)
    const [showSortMenu,setShowSortMenu] = useState(false)
    const [pageModals,setPageModals] = useState({add:false,view:null,edit:null,delete:null,menu:null,settings:false})
    const fetching = useRef(true)
    const [searching,setSearching] = useState(false)
    const searchingTimer = useRef(null)
    const user = useSelector((state) => state.authState.user)
    const searchValue = useSelector((state) => state.noteState.search)
    const sortParams = useSelector((state)=> state.noteState.sortParams)
    const filterParams = useSelector((state) => state.noteState.filterParams)
    const notes = useSelector((state) => state.noteState.notes)
    const loading = useSelector((state) => state.noteState.fetching)
    const crashError = useSelector((state) => state.noteState.fetchError)
    const dispatch = useDispatch()

    const inputModalOpen = useMemo(()=>{
        return pageModals.settings || pageModals.add || pageModals.edit !== null || showFilterMenu
    },[pageModals])

    UseViewportPadding(!inputModalOpen)

    useEffect(()=>{
        if (fetching.current){
            fetching.current = false
            dispatch(getNotes())
            if (user.isDemoUser){
                toast.dismiss()
                toast(<DemoToast/>, {
                    position: "bottom-left",
                    autoClose: false,
                    closeOnClick: false,
                    draggable: false,
                    hideProgressBar: true,
                    closeButton: false,
                    className: styles.toastWrapper
                })
            }
        }
        return () => {
            fetching.current = false
        }
    },[dispatch,user?.isDemoUser])

    const handleFilterSort = (attr,value) => {
        if (attr === "filter"){
            dispatch({type: SET_FILTERS, payload: value})
            dispatch(getNotes())
        }
        if (attr === "sort"){
            dispatch({type: SET_SORTING, payload: value})
            dispatch(getNotes())
        }
    }
  
    const handleSearchChange = (e) => {
        if (searchingTimer.current){
            clearTimeout(searchingTimer.current)
            setSearching(true)
        }
        dispatch({type: SET_SEARCH, payload: e.target.value})
        searchingTimer.current = setTimeout(()=>{
            setSearching(false)
            dispatch(getNotes())
        },1000)
    }

    const activeFilter = useMemo(()=>{
        return filterParams.color || filterParams.tags.length > 0
    },[filterParams])

    const activeSort = useMemo(()=>{
        return !(sortParams.field === "updatedAt" && sortParams.order === "desc")
    },[sortParams])

    const removeTagFilter = (tag_id) => {
        let tags = filterParams.tags.filter(tag => tag._id !== tag_id)
        handleFilterSort("filter",{...filterParams,tags})
    }

    const numFilters = useMemo(()=>{
        return (filterParams.color ? 1 : 0) + filterParams.tags.length
    },[filterParams])

    const handleScroll = () => {
        const isTest = process.env.REACT_APP_TEST_MODE?.trim() === "true"
        if (isTest) return
        if (pageModals.menu !== null){
            setPageModals({...pageModals,menu: null})
        }
        if (showFilterMenu){
            setShowFilterMenu(false)
        }
        if (showSortMenu){
            setShowSortMenu(false)
        }
        
    }

    const toggleAdd = () => {
        toast.dismiss()
        dispatch({type: "MODAL_RESET"})
        setPageModals({...pageModals,add:true})
    }

    const handleRetry = () => {
        dispatch(getNotes())
        dispatch({type: CRASH_ERROR, payload: false})
    }

    return (
        <PageContext.Provider value = {[pageModals,setPageModals]}>
            {crashError ? 
                <div className = {styles.wrapper}>
                    <header>
                        <nav className={styles.navbar}>
                            <div className = {styles.navbarContent}>
                                <LogoItem/>
                                <div className={styles.navRight}>
                                    <div className={styles.navAvatar} onClick = {()=>setShowUserMenu(!showUserMenu)}>{user?.fullname?.charAt(0)?.toUpperCase() || ""}</div>
                                    {showUserMenu && <UserMenu closeMenu = {()=>setShowUserMenu(false)}/>}
                                </div>
                            </div>
                        </nav>
                    </header>
                    <CrashPage handleRetry = {()=>handleRetry()}/>
                </div> : notes ? <div className = {`${styles.wrapper} ${(searching || loading) ? styles.search : ""}`} id = "board" onScroll = {handleScroll}>
                    <div className = {styles.boardContent} id = "content">
                        <header>
                            <nav className={styles.navbar}>
                                <div className = {styles.navbarContent}>
                                    <LogoItem/>
                                    <div className={styles.navSearch}>
                                        <span className={styles.navSearchIcon}>🔍</span>
                                        <div className = {styles.searchContainer}>
                                            <input data-testid = "notes-search" type="text" placeholder="Search notes by title or content…" value={searchValue} onChange={handleSearchChange}/>
                                        </div>
                                    </div>
                                    <div className={styles.navRight}>
                                        <div data-testid = "user-btn" className={styles.navAvatar} onClick = {()=>setShowUserMenu(!showUserMenu)}>{user?.fullname?.charAt(0)?.toUpperCase() || ""}</div>
                                        {showUserMenu && <UserMenu closeMenu = {()=>setShowUserMenu(false)}/>}
                                    </div>
                                </div>
                            </nav>
                            <div className = {styles.searchWrapper}>
                                <div className={styles.navSearch}>
                                    <span className={styles.navSearchIcon}>🔍</span>
                                    <div className = {styles.searchContainer}>
                                        <input data-testid = "notes-search" type="text" placeholder="Search notes by title or content…" value={searchValue} onChange={handleSearchChange} />
                                    </div>
                                </div>
                            </div>
                            <div className={styles.pageHeader}>
                                <div className = {styles.row}>
                                    <div className={styles.pageHeaderLeft}>
                                        <div className={styles.pageTitle}>My Notes</div>
                                        {(!loading && !searching) && <div data-testid = "notes-count" className={styles.pageCount}>{notes.length} <span>notes</span></div>}
                                    </div>
                                    <div className={styles.pageActions}>
                                        <div className = {styles.btnWrapper}>
                                            {!activeSort ? 
                                            <button data-testid = "sort-btn" type = "button" className= {`${styles.btnSort} ${showSortMenu ? styles.open : ""}`} onClick = {()=>setShowSortMenu(!showSortMenu)}>
                                                <div className = {styles.sortIcon}><TbArrowsSort/></div>
                                                <span>Sort</span>
                                            </button> : 
                                            <button data-testid = "sort-btn" type = "button" className= {`${styles.btnSort} ${styles.active} ${showSortMenu ? styles.open : ""}`} onClick = {()=>setShowSortMenu(!showSortMenu)}>
                                                <div className = {styles.sortIcon}>{sortIcons[sortParams.field]}:</div>
                                                <div data-testid = {`sort-${sortParams.order}`} className = {styles.orderIcon}>{sortParams.order === "desc" ? <FaArrowDownLong /> : <FaArrowUpLong />}</div>
                                                <span data-testid = "active-sort">{attrDict[sortParams.field]}</span>
                                            </button>}
                                        {
                                            showSortMenu && 
                                            <SortMenu 
                                                sortParams={sortParams}
                                                onChangeSortParams={(value)=>handleFilterSort("sort",value)}
                                                closeMenu = {()=>setShowSortMenu(false)}
                                            />
                                        }
                                        </div>
                                        <div className = {styles.btnWrapper}>
                                            {!activeFilter ? 
                                                <button data-testid = "filter-btn" type = "button" className = {`${styles.btnFilter} ${showFilterMenu ? styles.open : ""}`}  onClick = {()=>setShowFilterMenu(!showFilterMenu)}>
                                                    <div className = {styles.filterIcon}><IoFunnel/></div>
                                                    <span>Filter</span>
                                                </button> : 
                                                <button type = "button" className = {`${styles.btnFilter} ${styles.active} ${showFilterMenu ? styles.open : ""}`}  onClick = {()=>setShowFilterMenu(!showFilterMenu)}>
                                                    <span>Filter</span>
                                                    <div className = {styles.filterIcon}><IoFunnel/>:</div>
                                                    <div className = {styles.diamond}>
                                                        <span className = {styles.numFilters}>{numFilters}</span>
                                                    </div>
                                                </button>
                                            } 
                                            {
                                                showFilterMenu && 
                                                <FilterMenu
                                                    filterParams={filterParams}
                                                    onChangeFilterParams={(value)=>handleFilterSort("filter",value)}
                                                    closeMenu = {()=>setShowFilterMenu(false)}
                                                />
                                            }
                                        </div>
                                        <button data-testid = "add-btn" className={styles.btnAdd} onClick = {()=>toggleAdd()}>
                                            <div className = {styles.btnAddIcon}><BsPlus/></div>
                                            <span>Add Note</span>
                                        </button>
                                    </div>
                                </div>
                                {activeFilter && <div className={styles.activeFilters}>
                                    {filterParams.color && <div data-testid = "filter-color" className={styles.activeFilterPill} style = {{ color: filterParams.color.code}}>
                                        <span className={styles.filterDot} style = {{ backgroundColor: filterParams.color.code}}></span>
                                            {filterParams.color.name}
                                        <button type = "button" onClick = {()=>handleFilterSort("filter",{...filterParams,color:null})} style = {{ color: filterParams.color.code}}>×</button>
                                    </div>}
                                    {filterParams.tags.map((tag)=> (
                                        <div data-testid = {`filter-tag-${tag._id}`} className={styles.activeFilterPill} key = {tag._id}>
                                            🏷️ {tag.name} <button type = "button" onClick = {()=>removeTagFilter(tag._id)}>×</button>
                                        </div>
                                    ))}   
                                    <button className={styles.clearAll} onClick = {()=>handleFilterSort("filter",{color: null, tags: []})}>Clear all</button>
                                </div>}
                            </div>
                        </header>
                        <div className={styles.main}>
                            <main className={styles.content}>
                            {(loading || searching) ? 
                                <SkeletonNoteContainer/> : 
                                notes.length ? <div className={styles.notesGrid} id = "notes-grid">
                                {notes.map((note)=>(
                                    <NoteCard note = {note} key = {note._id}/>
                                ))}
                            </div> : (activeFilter || searchValue) ? <EmptyResults/> : <NoNotes/>}
                            </main>
                        </div>
                    </div>
                </div> : <SkeletonPage/>}
            {pageModals.settings && <Settings/>}
            {pageModals.add && <AddNote closeMenu = {()=>setPageModals({...pageModals,add:false})}/>}
            {pageModals.edit !== null && <EditNote/>}
            {pageModals.delete !== null && <DeleteNote id = {pageModals.delete}/>}
            {pageModals.view !== null  && <ViewNote/>}
        </PageContext.Provider>
  )
}
export default Notes